import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { Copy, Check, Share2, QrCode } from "lucide-react";

// Admin-only card: shareable branded invite link + QR code for recruiting partners.
export default function ShareInvite({ org }) {
  const [copied, setCopied] = useState(false);
  if (!org?.slug) return null;

  const link = `${window.location.origin}/${org.slug}`;
  const accent = org.accent_color || "#C9973A";

  const copy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    toast.success("Invite link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  const share = async () => {
    const data = { title: `Follow ${org.org_name}`, text: `Follow ${org.org_name}'s mission journey — pray, give and stay connected.`, url: link };
    if (navigator.share) {
      try { await navigator.share(data); } catch { /* user cancelled */ }
    } else {
      copy();
    }
  };

  return (
    <div data-testid="share-invite-card" className="bg-white rounded-3xl p-6 shadow-[0_4px_24px_rgba(44,44,62,0.04)]">
      <div className="flex items-center gap-2 mb-1">
        <QrCode className="h-4 w-4 accent-text" />
        <h2 className="font-heading font-bold text-lg text-[var(--brand-navy)] leading-tight">Share your invite link</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4">Send this to supporters by text, email or social — they'll land on your branded page and join in seconds.</p>

      <div className="flex items-center gap-4">
        <div className="rounded-2xl p-2.5 bg-white border shrink-0" data-testid="share-invite-qr">
          <QRCodeSVG value={link} size={92} bgColor="#ffffff" fgColor={accent} level="M" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="rounded-xl bg-muted/50 px-3 py-2 text-sm text-[#2C2C3E] truncate" data-testid="share-invite-link">
            {link.replace(/^https?:\/\//, "")}
          </div>
          <div className="flex gap-2 mt-3">
            <button data-testid="share-invite-copy" onClick={copy}
              className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full border h-10 text-sm font-medium text-[#2C2C3E] hover:bg-muted/40 transition-colors">
              {copied ? <Check className="h-4 w-4 accent-text" /> : <Copy className="h-4 w-4" />} {copied ? "Copied" : "Copy"}
            </button>
            <button data-testid="share-invite-share" onClick={share}
              className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-full h-10 text-sm font-semibold text-white hover:opacity-90 transition-opacity" style={{ background: accent }}>
              <Share2 className="h-4 w-4" /> Share
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
